module.exports = __webpack_public_path__ + "static/media/intro.4122678d.mp3";